<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Lançamento"
            @click.stop="confirmarExcluir(prestacaoContasFinalLancamento.idPrestacaoContasFinal)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {

    props: {
        convenio: Object,
        prestacaoContasFinalLancamento: Object,
    },

    methods: {
        confirmarExcluir(id){
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir o Lançamento ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id){
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirPrestacaoContaFinal(id)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarLista')
                        this.$emit('ocorreuAlteracao')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
}
</script>
